<script lang="ts">
import { useTailwind } from '@/plugins/useTailwind'
import { defineComponent, useTemplateRef } from 'vue'

import type AppCarousel from '../carousel/AppCarousel.vue'
import CarouselItem from '../carousel/CarouselItem.vue'

/**
 * The "Product" overview page.
 */
export default defineComponent({
  components: {
    CarouselItem,
  },
  setup() {
    const tailwind = useTailwind()
    const bannerRef = useTemplateRef<HTMLElement>('bannerRef')
    const carouselRef =
      useTemplateRef<InstanceType<typeof AppCarousel>>('carouselRef')

    return {
      tailwindBreakpoints: tailwind.breakpoints,
      bannerRef,
      carouselRef,
    }
  },
  data() {
    return {
      partnerships: [
        {
          name: 'The Daily Mail',
          logo: '/assets/images/partners/daily-mail_logo.svg',
        },
        {
          name: 'The Mirror',
          logo: '/assets/images/partners/the-mirror_logo.svg',
        },
        {
          name: 'Joe Media',
          logo: '/assets/images/partners/joe-media_logo.svg',
        },
        {
          name: 'Vodafone',
          logo: '/assets/images/partners/vodafone_logo.svg',
        },
        {
          name: 'Wowcha',
          logo: '/assets/images/partners/wowcha_logo.svg',
        },
        {
          name: 'Mumsnet',
          logo: '/assets/images/partners/mumsnet_logo.svg',
        },
      ],
    }
  },
})
</script>

<template>
  <AppBanner labelled-by="as-seen-in-section">
    <div ref="bannerRef" class="as-seen-in-section">
      <span id="as-seen-in-section" class="sr-only"
        >{{ BUSINESS_NAME }} + Partnership's Logos</span
      >

      <AppCarousel
        ref="carouselRef"
        title="As Seen In"
        :icon="Icons.Megaphone"
        :autoplay="false"
        :autoplay-delay="0"
      >
        <CarouselItem
          v-for="(partnership, key) in partnerships"
          :key
          class="flex items-center justify-center"
        >
          <div
            class="flex h-full justify-center rounded-lg bg-pure-white px-6 py-4"
          >
            <img :src="partnership.logo" :alt="partnership.name" />
          </div>
        </CarouselItem>
      </AppCarousel>
    </div>
  </AppBanner>
</template>

<style lang="scss" scoped>
.as-seen-in-section:deep(.scrollbox) {
  @apply -mx-3 bg-primary bg-[url('@/assets/images/partners/partnerships-bg.svg')] bg-[length:100%_100%] bg-no-repeat px-3 py-6 @md/main:mx-0 @md/main:rounded-lg @md/main:px-6;

  > ul {
    @apply justify-between;
  }
}
</style>
